import React from "react";
import "./Components.scss";

const Hero = () => {
	return <div className="heroImage"></div>;
};

export default Hero;
